import "./wdyr"; // Has to be the first import

import React from "react";
import { createRoot } from "react-dom/client";
import "./tailwind.css";
import "@k8slens/lds-tokens/lib/web/font-imports.css";
import "@k8slens/lds/lib/es/index.css";
import "@k8slens/lds/lib/es/typography.css";
import "@k8slens/lds-form/lib/es/index.css";
import "@k8slens/lds-tips/lib/es/index.css";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
